import dynamic from "next/dynamic";
const ContactOptionsEmbeddedComponent = dynamic(()=>import("./contact-options-embedded-component"));
import ContactOptionsEmbeddedConfig from "./contact-options-embedded-config";
import ContactOptionsEmbeddedAdvancedConfig from "./contact-options-embedded-advanced-config";
export default {
    ContactOptionsEmbeddedComponent,
    ContactOptionsEmbeddedConfig,
    ContactOptionsEmbeddedAdvancedConfig
};
